export default "__VITE_ASSET__CTmt0a6u__"